import { useEffect, useState } from "react";

import { api } from "../../lib/api";
import { ShipmentProps } from "../../types/shipment";
import { List } from "../../types/resquest";
import { getToken } from "../../storage/auth";
import {DataTableUtils} from "../../components/DataTable/DataTableUtils";

interface IList {
  ID_CENTRO?: number;
  keyword?: string;
  page?: number;
  limit?: number;
  sort?: string;
}

const entity = "shipmentInstructions";
const dataTableUtils = new DataTableUtils(entity);

export const useList = (
  params?: IList,
  token?: string,
  isCombo?: boolean
): {
  data: ShipmentProps[];
  meta: List;
  isLoading: boolean;
  combo: any[];
  error: Error;
} => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<ShipmentProps[]>([{} as ShipmentProps]);
  const [meta, setMeta] = useState<List>({} as List);
  const [error, setError] = useState<Error>({} as Error);
  const [combo, setCombo] = useState<any>();

  const render = () => {
    if (token) {
      if (isCombo === false || isCombo === undefined) {
        return "pagination";
      }
    }
  };
  useEffect(() => {
    if (render() === "pagination") {
      (async function () {
        setIsLoading(true);
        const response = await dataTableUtils.findPaginate(params);
        const {total, data, currentPage, totalPages, limit} = response.data;
        setData(data);
        setMeta((prevState) => ({
          ...prevState,
          total,
          totalPages,
          limit,
          currentPage,
        }));
        setIsLoading(false)
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, token, isCombo]);

  useEffect(() => {
    if (token && isCombo === true) {
      setIsLoading(true);
      api
        .get(`/${entity}/getCombo`, {
          params: {
            ...(params?.ID_CENTRO && { ID_CENTRO: params?.ID_CENTRO }),
          },
          headers: { authorization: `Bearer ${token}` },
        })
        .then((response) => {
          const { data } = response;
          setCombo(data);
        })
        .catch(setError)
        .finally(() => setIsLoading(false));
    }
  }, [isCombo, params, token]);

  return { data, meta, isLoading, combo, error };
};

export const update = async (
  id: number | string,
  currency?: ShipmentProps
): Promise<ShipmentProps> => {
  const token = getToken();
  const { data } = await api.patch(`/${entity}/${id}`, currency, {
    headers: { authorization: `Bearer ${token}` },
  });

  return data;
};
export const deleteShipment = async (
  id: number | string
): Promise<ShipmentProps> => {
  const token = getToken();
  const { data } = await api.delete(`/${entity}/${id}`, {
    headers: { authorization: `Bearer ${token}` },
  });

  return data;
};

export const isInUse = async (id: number | string): Promise<any> => {
  const token = getToken();
  const { data } = await api.get(`/${entity}/isInUse/${id}`, {
    headers: { authorization: `Bearer ${token}` },
  });

  return data;
};

export const create = async (currency: any): Promise<any> => {
  const token = getToken();
  const { data } = await api.post(`/${entity}`, currency, {
    headers: { authorization: `Bearer ${token}` },
  });

  return data;
};

export const createCopy = async (
  currency: ShipmentProps[]
): Promise<ShipmentProps[]> => {
  const token = getToken();
  const { data } = await api.post(`/${entity}/copy`, currency, {
    headers: { authorization: `Bearer ${token}` },
  });

  return data;
};

export const exportAll = async (params: any) => {
  let xlsxData = [
    { label: "Id", value: "ID_INSTRUCAO_EMBARQUE" },
    { label: "Description", value: "DSC_INSTRUCAO" },
    { label: "Company abbreviation", value: "GE_SIGLA_EMPRESA" },
    { label: "Center abbreviation", value: "GC_DSC_SIGLA" },
    { label: "Center name", value: "GC_NOME_CENTRO" },
    {
      label: "Status",
      value: (row: any) => (row.ATIVO ? "Active" : "Inactive"),
    },
  ]
  await dataTableUtils.exportAll({params, xlsxData, filename: "ShipmentInstruction"});
};

export const getCenters = async (center: { id: any; }) => {
  if(!center?.id) return;
  const { data } =  await dataTableUtils.findPaginate({
    ID_CENTRO: center.id,
    ATIVO: true,
    page: 1
  });
  return data;
}